import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import styles from './QuestionEditorCompactItem.sass'
import { QuestionViewModel } from 'jobs/questions/component-registry'
import { QuestionTitle, QuestionDescription } from '../QuestionContent'
import { useToggle } from 'hooks/state-hooks'

interface Props {
  question: QuestionViewModel
  children?: React.ReactNode
  compact?: boolean
}

export default observer(function QuestionEditorCompactItem({
  question,
  children,
  compact,
}: Props) {
  const showingDescToggle = useToggle(false)
  return (
    <div className={cx(styles.root, compact && styles.compactRoot)}>
      <div className={styles.details}>
        <div
          className={styles.info}
          title={`${question.question}\n-------\n${question.description}`}
        >
          <QuestionTitle
            compact
            title={question.question}
            onInfoClick={
              question.description ? showingDescToggle.toggle : undefined
            }
          />
          <QuestionDescription
            description={question.description}
            hidden={!showingDescToggle.isEnabled}
          />

          {/* <p className={styles.title}>{question.question}</p> */}
        </div>
        <div className={cx(styles.editor, compact && styles.compactEditor)}>
          {children}
        </div>
        {question.validationErrors.length > 0 && (
          <div className={styles.errors}>
            {question.validationErrors.join(' / ')}
          </div>
        )}
      </div>
    </div>
  )
})
